import type { ReactNode } from "react";

import { LockIcon } from "lucide-react";

import { styled } from "simplydo/react/styled";
import { Popup } from "simplydo/react/ui/popup";

import { Checkbox } from "./Checkbox";
import type { CheckboxProps } from "./Checkbox.types";

export type LockedToggleProps = Omit<CheckboxProps, "toggle" | "icon"> & {
  /** Defaults to true; when false this renders a regular toggle. */
  locked?: boolean;
  /** Shown in a popup anchored to the toggle track while locked. */
  reason?: ReactNode;
};

const LockedToggleComponent = (props: LockedToggleProps) => {
  const { locked = true, reason, disabled, ...rest } = props;

  if (!locked) {
    return <Checkbox {...rest} disabled={disabled} toggle />;
  }

  const toggle = <Checkbox {...rest} disabled toggle icon={LockIcon} />;
  if (!reason) {
    return toggle;
  }
  return (
    <Popup trigger={toggle} position="top left">
      {reason}
    </Popup>
  );
};

export const LockedToggle = styled(LockedToggleComponent)``;
